/**
 * Update-media-description request validator — SCRUM-147 / DS-011-6.
 *
 * HTTP-boundary Zod schema for the description PATCH payload
 * (`PATCH /organizations/:slug/properties/:propertyId/media/:mediaId/description`).
 *
 * `description` is a string of at most 255 characters, or `null` (clear).
 * The 255 cap mirrors the MediaDescription VO and the `description_len` DB
 * CHECK. The VO additionally trims and coerces empty → null inside the use
 * case; this schema rejects 256+ chars at the wire boundary with a clean 400.
 * Exactly 255 chars is accepted (boundary).
 */
import { z } from 'zod';
/** Mirrors MediaDescription VO + description_len DB CHECK. */
export const MEDIA_DESCRIPTION_MAX_LENGTH = 255;
export const updateMediaDescriptionSchema = z.object({
    description: z.string().max(MEDIA_DESCRIPTION_MAX_LENGTH).nullable(),
});
//# sourceMappingURL=update-media-description.schema.js.map